import React, { useState, useEffect } from 'react'
import { Button, ButtonToolbar, Col, Icon, Panel, Row, Tooltip, Whisper } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import { downloadSubProjectIncomeRecordAttacthment } from '../../../redux/actions/subProjectIncomeRecord'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import {
  sessionGetItemObj,
  sessionGetItemStr,
  sessionRemoveItem,
} from '../../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom'
import globalMsgUtil from '../../../utils/globalMsgUtil'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import DirectorFollowAuditIssuesForm from './DirectorFollowAuditIssuesForm'
import { saveDraftDirectorAudit } from '../../../redux/actions/directorAudit'
import pathname from '../../../constants/pathname'
import { downloadAuditIAp10 } from '../../../redux/actions/auditReportSummary'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'

export default function DirectorFollowAuditIssuesWidget(props) {
  // const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [requestBody, setRequestBody] = useState()

  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [isSaveDraft, setIsSaveDraft] = useState(false)
  const [isViewMode, setIsViewMode] = useState(false)

  let history = useHistory()
  const auditInfo = sessionGetItemObj('auditInfo')

  useEffect(() => {
    let isViewMode = !!sessionGetItemStr('directorAuditViewMode')
    if (isViewMode) {
      setIsViewMode(isViewMode)
      sessionRemoveItem('directorAuditViewMode')
    }
  }, [])

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await saveDraftDirectorAudit(requestBody, formSchema?.form?.id, isSaveDraft)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setRequestBody()
        setIsShowConfimModal(false)
        if (!isSaveDraft) {
          history.push(`${pathname.proposal.overview.overviewCoworker}`)
        }
      } else {
        setIsError()
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
      } else {
        setIsError(globalMsgUtil.SET_IS_ERROR)
      }
      setIsShowConfimModal(false)
    }

    setIsLoading(false)
    doneLoading()
    setIsSaveDraft(false)
  }

  const onSubmit = (data) => {
    // console.log('data===>', data)

    let request = {
      id: formSchema?.form?.id,
      approverType: data.approveOption,
      comment: data.approveComment,
      reveiwSelect: data.coordinatorOption || [],
    }
    // console.log('request===>', request)
    setRequestBody(request)
    setIsShowConfimModal(true)
  }

  const handleCancel = () => {
    // console.log('handleCancel')
    sessionRemoveItem('auditInfo')

    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  const onSubmitDraft = () => {
    var data = {
      id: formSchema?.form?.id,
      approverType: getValues('approveOption'),
      comment: getValues('approveComment'),
      reveiwSelect: getValues('coordinatorOption'),
    }

    setRequestBody(data)
    setIsSaveDraft(true)
    setIsShowConfimModal(true)
  }

  const handleOnConfirmModal = () => {
    handleCallService()
  }

  const onPreview = async (filePath) => {
    startLoading()
    try {
      var files = filePath?.split('/')
      var file = await downloadSubProjectIncomeRecordAttacthment(filePath)

      previewFile(file, files[files.length - 1])
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDownloadIAp10 = async () => {
    console.log('handleDownloadIAp10 ')

    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadAuditIAp10(
        formSchema?.form?.id || '',
        '' || formSchema?.projectInfo?.id
      )

      if (file) {
        downloadFile(file, file.name || `รายงานตรวจสอบภายใน_IAp10`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={''} bordered>
        {/* <InfoReportsAudit schema={formSchema?.projectInfo} showButton={true} /> */}

        {formSchema?.form && (
          <DirectorFollowAuditIssuesForm
            schema={formSchema?.form}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            setIsEnableEdit={setIsEnableEdit}
            isViewMode={isViewMode}
          />
        )}

        {!isViewMode && (
          <Row style={{ marginTop: 20 }}>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ButtonToolbar style={{ textAlign: 'right' }}>
                <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={
                    <Tooltip>
                      คลิกเพื่อ <i>ดาวน์โหลดไฟล์ IAp10</i>
                    </Tooltip>
                  }
                >
                  <Button
                    color="blue"
                    appearance="link"
                    onClick={() => {
                      handleDownloadIAp10()
                    }}
                  >
                    <Icon icon="eye" size="lg" /> IAp10
                  </Button>
                </Whisper>
                {/* <PrintButton
                  children="IAp10"
                  onClick={() => {
                    handleDownloadIAp10()
                  }}
                /> */}

                {formSchema?.form?.button?.saveButton && (
                  <SaveButton
                    onClick={() => {
                      onSubmitDraft()
                    }}
                    disabled={isLoading}
                  >
                    {formSchema?.form?.button?.saveButton}
                  </SaveButton>
                )}

                {formSchema?.form?.button?.submitButton && (
                  <SaveButton onClick={handleSubmit(onSubmit)}>
                    {formSchema?.form?.button?.submitButton}
                  </SaveButton>
                )}

                <CancelButton
                  onClick={() => {
                    handleCancel()
                  }}
                >
                  {'ยกเลิก'}
                </CancelButton>
              </ButtonToolbar>
            </Col>
          </Row>
        )}
      </Panel>

      <ConfirmWidget
        title={`ยืนยันการ${isSaveDraft ? 'บันทึกร่าง' : formSchema.buttonText || 'บันทึก'}`}
        show={isShowConfimModal}
        // detail={`กรุณายืนยันการ${isSaveDraft ? 'บันทึกร่าง' : formSchema.buttonText}`}
        onCancle={() => {
          setIsSaveDraft(false)
          setIsShowConfimModal(false)
        }}
        onConfirm={handleOnConfirmModal}
      />
    </>
  )
}
